// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "canvas{margin-left:auto;margin-right:auto;width:390px;max-width:100%}@media (min-width: 640px){canvas{width:600px}}@media (min-width: 768px){canvas{width:100%}}", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,OAAA,gBAAA,CAAA,iBAAA,CAAA,WAAA,CAAA,cAAA,CAAA,0BAAA,OAAA,WAAA,CAAA,CAAA,0BAAA,OAAA,UAAA,CAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
